import React from 'react';
import { MenuItem, Typography } from '@mui/material';
//
import { FormikContext, FormikCountry, FormikField } from '@components/formik';
import ObTooltip from './ObTooltip';
import { useFormikContext } from 'formik';
import { useAuthContext } from '../auth';

const BusinessType: React.FC = () => {
  const { obData } = useAuthContext();
  const { setSteps, steps } = React.useContext(FormikContext);
  const [newSteps, setNewSteps] = React.useState([steps]);
  const { values } = useFormikContext();

  // Check for values and update the steps and substeps
  //  Example Stesps:  [
  //     {
  //         "label": "Verify your business",
  //         "isCompleted": false,
  //         "subSteps": [
  //             {
  //                 "label": "Business type",
  //                 "isCompleted": false
  //             },
  //             {
  //                 "label": "Business details",
  //                 "isCompleted": false
  //             },
  //             {
  //                 "label": "Business representative",
  //                 "isCompleted": false
  //             },
  //             {
  //                 "label": "Public details",
  //                 "isCompleted": false
  //             }
  //         ],
  //         "hasError": false
  //     },
  //     {
  //         "label": "Add your bank",
  //         "isCompleted": false,
  //         "subSteps": [
  //             {
  //                 "label": "Business details",
  //                 "isCompleted": false
  //             }
  //         ],
  //         "hasError": false
  //     },
  //     {
  //         "label": "Verify your documents",
  //         "isCompleted": false,
  //         "subSteps": [
  //             {
  //                 "label": "Document upload",
  //                 "isCompleted": false
  //             }
  //         ],
  //         "hasError": false
  //     },
  //     {
  //         "label": "Review and finish",
  //         "isCompleted": false,
  //         "subSteps": [
  //             {
  //                 "label": "Summary",
  //                 "isCompleted": false
  //             }
  //         ],
  //         "hasError": false
  //     }
  // // ]
  // React.useEffect(() => {
  //   if (!steps || !steps.length) return;

  //   setNewSteps(steps);

  //   // Check if values.country & values.type
  //   if (values.country !== '' && values.type !== '') {
  //     // Check if steps[0].isCompleted is false
  //     if (steps[0].isCompleted === false) {
  //       // Update steps[0].isCompleted to true
  //       const _newSteps = [...steps];
  //       _newSteps[0].isCompleted = true;
  //       setSteps(_newSteps);
  //     }
  //   }
  // }, [values, obData]);

  return (
    <>
      <Typography variant="h4" component="h2" gutterBottom>
        Let's start with some basics
      </Typography>
      <Typography variant="body1" gutterBottom color="text.secondary">
        Choose your location and business type to get started.
      </Typography>

      <ObTooltip
        title={
          <Typography variant="body2">
            If your country isn't listed, send us an email at
            {import.meta.env.VITE_SITE === 'Paybilt' ? (
              <a href="mailto:merchants@paybilt.com"> merchants@paybilt.com</a>
            ) : (
              <a href="mailto:merchants@payper.ca"> merchants@payper.ca</a>
            )}
          </Typography>
        }
      >
        <FormikCountry
          name="country"
          label="Business location"
          maxHeight={220}
        />
      </ObTooltip>

      <FormikField name="type" label="Type of business" select>
        <MenuItem value="corporation">Corporation</MenuItem>
        <MenuItem value="sole">Individual or sole proprietorship</MenuItem>
        <MenuItem value="non_profit">Nonprofit organization</MenuItem>
        <MenuItem value="partnership">Partnership</MenuItem>
      </FormikField>
    </>
  );
};

export default BusinessType;
